import {FilterSet} from 'hooks/use-filter-set'
import {atom} from 'jotai'
import {EmployeesReportFilters} from 'ui/toolbars/report-toolbar'

export const jobSearchAtom = atom('')
export const jobListViewAtom = atom('list')
